const superAdminPreStoreModules = ["DASHBOARD", "STORES", "STOREADMIN"];

export const moduleRouteMap = {
  DASHBOARD: {
    sidebarKey: "dashboard",
    routes: ["/", "/dashboard"],
  },
  // ASSET: {
  //   sidebarKey: "assets",
  //   routes: ["/gallery"],
  // },
  PRODUCT: {
    sidebarKey: "products",
    routes: ["/product", "/product/add-new"],
  },
  CATEGORY: {
    sidebarKey: "category",
    routes: ["/category", "/category/add-new", "/category/edit/:id"],
  },
  CUSTOMER: {
    sidebarKey: "customer",
    routes: ["/customer/all", "/customer/details/:id"],
  },
  STORE: {
    sidebarKey: "my-store",
    routes: ["/stores/edit/:id/:type"],
  },
  STORES: {
    sidebarKey: "stores",
    routes: [
      "/stores/list",
      "/stores/add-new/general",
      "/stores/edit/:id/:type",
      "/stores/admin/list",
      "/stores/admin/add-new",
      "/stores/admin/edit/:id",
      "/stores/admin/change-password/:id",
      "/stores/admin/permissions/:id",
    ],
  },
  STAFF: {
    sidebarKey: "staff",
    routes: [
      "/users",
      "/users/edit/:id",
      "/users/add-new",
      "/users/change-password/:id",
      "/users/permissions/:id",
    ],
  },
  STOREADMIN: {
    sidebarKey: "storeadmin",
    routes: ["/users", "/user/my-profile", "/user/change-password"],
  },
  CMS: {
    sidebarKey: "cms",
    routes: ["/cms/:id"],
  },
  CUSTOMIZATION: {
    sidebarKey: "customization",
    routes: [
      "/form",
      "/form/add-new",
      "/form/edit/:id",
      "/submissions",
      "/submissions/:formId",
      "/submissions/:formId/:id",
    ],
  },
  // SITEMAP: {
  //   sidebarKey: "sitemap",
  //   routes: ["/sitemap", "/sitemap/add-new", "/sitemap/edit/:id"],
  // },
  BRAND: {
    sidebarKey: "brand",
    routes: ["/brand", "/brand/add-new", "/brand/edit/:id"],
  },
  WISHLIST: {
    sidebarKey: "wishlist",
    routes: ["/wishlist", "/wishlist/user/:id"],
  },
  QUERIES: {
    sidebarKey: "queries",
    routes: ["/queries"],
  },
  COUPON: {
    sidebarKey: "coupon",
    routes: ["/coupon", "/coupon/add-new", "/coupon/edit/:id"],
  },
  DEALOFTHEDAY: {
    sidebarKey: "deal-of-the-day",
    routes: [
      "/deal-of-the-day",
      "/deal-of-the-day/add-new",
      "/deal-of-the-day/edit/:id",
    ],
  },
  BLOG: {
    sidebarKey: "blog",
    routes: ["/blog", "/blog/add-new", "/blog/edit/:id"],
  },
  BANNER: {
    sidebarKey: "banners",
    routes: ["/banners", "/banners/add-new", "/banners/edit/:id"],
  },
  SETTING: {
    sidebarKey: "my-store",
    routes: ["/cms/:id", "/user/my-profile", "/user/change-password"],
  },
  TESTIMONIAL: {
    sidebarKey: "testimonials",
    routes: [
      "/testimonials",
      "/testimonials/add-new",
      "/testimonials/edit/:id",
    ],
  },
  ORDER: {
    sidebarKey: "orders",
    routes: [
      "/orders/:id",
      "/orders/details/:id",
      "/orders/invoice/:id",
      "/orders/label/:id",
    ],
  },
  INVENTORY: {
    sidebarKey: "inventory",
    routes: [
      "/suppliers",
      "/suppliers/add-new",
      "/suppliers/edit/:id",
      "/purchase-invoices",
      "/purchase-invoices/add-new",
      "/purchase-invoices/edit/:id",
      "/stock-history",
      "/inventory-list",
    ],
  },
  SHIPPING: {
    sidebarKey: "shipping",
    routes: ["/shipments/all", "/shipments/delivered", "/shipments/cancelled"],
  },
  POS: {
    sidebarKey: "pos",
    routes: ["/pos", "/pos/offline-sales", "/pos/offline-sales/:id"],
  },
};

export const generateAccessFromPermissions = (user, selectedStore) => {
  if (!user) return { sidebar: [], routes: [] };

  const sidebar = [];
  const routes = [];

  // ALWAYS include dashboard
  const dashboardConfig = moduleRouteMap["DASHBOARD"];
  if (dashboardConfig) {
    sidebar.push(dashboardConfig.sidebarKey);
    routes.push(...dashboardConfig.routes);
  }

  // SUPERADMIN Logic
  if (user.roles === "SUPERADMIN") {
    // ❌ Store NOT selected → limited access
    if (!selectedStore) {
      superAdminPreStoreModules.forEach((module) => {
        const config = moduleRouteMap[module];
        if (config) {
          sidebar.push(config.sidebarKey);
          routes.push(...config.routes);
        }
      });

      return { sidebar, routes };
    }

    // Store selected → full access
    Object.values(moduleRouteMap).forEach((config) => {
      sidebar.push(config.sidebarKey);
      routes.push(...config.routes);
    });

    return { sidebar, routes };
  }

  // Normal Users (permission based)
  const modules = new Set();

  user.permissions?.forEach((permission) => {
    const module = permission.split("_")[1];
    modules.add(module);
  });

  modules.forEach((module) => {
    const config = moduleRouteMap[module];

    if (config) {
      sidebar.push(config.sidebarKey);
      routes.push(...config.routes);
    }
  });

  return { sidebar, routes };
};
